import {
  ApplicationConfig, ErrorHandler, importProvidersFrom, inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AuthInterceptor} from './http-interceptors/auth.interceptor';
import {ErrorInterceptor} from './http-interceptors/error.interceptor';
import {MetaTitleService} from './services/meta-title/meta-title.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {environment} from '../environments/environment';
import {MicroSentryModule} from '@micro-sentry/angular';
import {AppErrorHandler} from './services/error-handler/app-error-handler.service';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom([MicroSentryModule.forRoot({
      dsn: environment.dsn,
    })]),
    {provide: ErrorHandler, useExisting: AppErrorHandler},
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom([TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    })]),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: LOCALE_ID, useValue: 'en-EN'},
    provideAppInitializer(() => {
      inject(MetaTitleService)
    }),
  ]
};
